/* ============ Pellamar motion layer (v3) ============
   Deferred, never render-blocking. The script hides elements only
   as it arms them, and only if they sit below the fold — so there
   is no window in which content can be invisible without a
   revealer already watching it. */
(function(){
  'use strict';

  var EASE='cubic-bezier(.16,1,.3,1)';
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  var canObserve=('IntersectionObserver' in window);
  var canAnimate=(typeof Element!=='undefined'&&typeof Element.prototype.animate==='function');

  /* Elements to reveal, paired with their per-row stagger in ms.
     .lv-arch is excluded from the .lv-mid sweep so its cells can
     stagger individually instead of fading as one slab. */
  var GROUPS=[
    ['.lv-intro > *',60],
    ['.lv-mid > *:not(.lv-arch)',60],
    ['.lv-arch__i',70],
    ['.lv-panel__t > *',60],
    ['.lv-faq details',45],
    ['.lv-panel__i',0],
    ['.lv-band',0]
  ];
  /* Only the side panels get the reveal-scale. The band image is left
     out on purpose: the parallax loop writes an inline transform to it
     every frame, which would silently cancel a class-based scale. */
  var MEDIA={'lv-panel__i':1};

  var io=null;
  function observer(){
    if(io||!canObserve){return io}
    io=new IntersectionObserver(function(entries){
      for(var i=0;i<entries.length;i++){
        if(!entries[i].isIntersecting){continue}
        entries[i].target.classList.add('lv-in');
        io.unobserve(entries[i].target);
      }
    },{rootMargin:'0px 0px -8% 0px',threshold:0});
    return io;
  }

  function arm(scope){
    if(!canObserve){return}
    var ob=observer();
    var vh=window.innerHeight||800;
    var fold=vh*0.88;

    for(var g=0;g<GROUPS.length;g++){
      var sel=GROUPS[g][0], step=GROUPS[g][1];
      var list;
      try{ list=scope.querySelectorAll(sel) }catch(err){ continue }
      var parents=[];
      for(var i=0;i<list.length;i++){
        var el=list[i];
        if(el.classList.contains('lv-armed')){continue}
        if(el.closest('.lv-hero')){continue}            /* hero animates in CSS */
        var p=el.parentElement;
        if(p&&p.closest('.lv-armed')){continue}          /* never nest reveals */

        /* Anything already on screen stays untouched — this is what
           makes a failed script harmless. */
        if(el.getBoundingClientRect().top<=fold){continue}

        if(step){
          var rec=null;
          for(var j=0;j<parents.length;j++){if(parents[j][0]===p){rec=parents[j]}}
          if(!rec){rec=[p,0];parents.push(rec)}
          var idx=rec[1]++;
          if(idx>5){idx=5}
          if(idx){el.style.setProperty('--lv-d',idx*step+'ms')}
        }

        el.classList.add('lv-armed');
        for(var m in MEDIA){if(el.classList.contains(m)){el.classList.add('lv-armed-media')}}
        ob.observe(el);
      }
    }
  }

  /* Belt and braces: if an observer ever fails to fire, nothing
     stays hidden. This also runs on scroll, so content further down
     the page is still revealed when the observer is the thing that
     broke — then detaches itself once there is nothing left to show. */
  function sweep(){
    var a=document.querySelectorAll('.lv-armed:not(.lv-in)');
    for(var i=0;i<a.length;i++){
      if(a[i].getBoundingClientRect().top<(window.innerHeight||800)){a[i].classList.add('lv-in')}
    }
    if(!document.querySelector('.lv-armed:not(.lv-in)')){
      window.removeEventListener('scroll',sweepSoon);
    }
  }

  var sweepQueued=false;
  function sweepSoon(){
    if(sweepQueued){return}
    sweepQueued=true;
    setTimeout(function(){sweepQueued=false;sweep()},150);
  }

  /* ---- scroll-linked motion ------------------------------------- */
  var hero=null,word=null,bands=[],ticking=false,scrolled=false;

  function clamp(v,lo,hi){return v<lo?lo:(v>hi?hi:v)}

  function frame(){
    ticking=false;
    var vh=window.innerHeight||800;

    /* The hero starts flush against the top of the document, so its
       progress is measured from the scroll position directly. The
       previous build reused the "enters from below" formula here,
       which read as ~50% progress at rest and faded the word out
       before the page had been scrolled at all. */
    if(word&&hero){
      var hh=hero.offsetHeight||vh;
      var p=clamp((window.pageYOffset||0)/hh,0,1);
      word.style.transform='translate3d(0,'+(p*80).toFixed(1)+'px,0)';
      word.style.opacity=clamp(1-p*1.7,0,1).toFixed(3);
    }

    for(var i=0;i<bands.length;i++){
      var b=bands[i];
      var r=b.box.getBoundingClientRect();
      if(r.bottom<-200||r.top>vh+200){continue}
      /* q: +1 fully below the viewport, 0 centred, -1 fully above.
         Travel stays at 3% of height against the 4%-per-side overhead
         that scale(1.08) provides, so an edge can never be exposed. */
      var c=r.top+r.height/2;
      var q=clamp((c-vh/2)/(vh/2+r.height/2),-1,1);
      b.img.style.transform='translate3d(0,'+(-q*r.height*0.03).toFixed(1)+'px,0) scale(1.08)';
    }
  }

  function request(){
    if(ticking){return}
    ticking=true;
    (window.requestAnimationFrame||function(f){setTimeout(f,16)})(frame);
  }

  function edge(){
    var s=(window.pageYOffset||0)>24;
    if(s!==scrolled){scrolled=s;document.body.classList.toggle('lv-scrolled',s)}
  }

  function initScroll(){
    edge();
    window.addEventListener('scroll',edge,{passive:true});
    if(reduce.matches){return}

    hero=document.querySelector('.lv-hero');
    word=hero?hero.querySelector('.lv-hero__w'):null;
    if(word){word.classList.add('lv-parallax')}

    var bl=document.querySelectorAll('.lv-band');
    for(var i=0;i<bl.length;i++){
      var im=bl[i].querySelector('img');
      if(im){im.classList.add('lv-parallax');bands.push({box:bl[i],img:im})}
    }
    if(!word&&!bands.length){return}
    window.addEventListener('scroll',request,{passive:true});
    window.addEventListener('resize',request,{passive:true});
    request();
  }

  /* ---- interruptible FAQ accordion ------------------------------- */
  function wireFaq(scope){
    if(!canAnimate){return}
    var list=scope.querySelectorAll('.lv-faq details');
    for(var i=0;i<list.length;i++){
      var d=list[i];
      if(d.getAttribute('data-lv-faq')==='1'){continue}
      d.setAttribute('data-lv-faq','1');
      bind(d);
    }
  }

  function bind(d){
    var sum=d.querySelector('summary');
    if(!sum){return}
    var wrap=document.createElement('div');
    wrap.className='lv-faq__c';
    while(sum.nextSibling){wrap.appendChild(sum.nextSibling)}
    d.appendChild(wrap);
    var anim=null;

    sum.addEventListener('click',function(ev){
      ev.preventDefault();
      if(reduce.matches){d.open=!d.open;return}

      /* Grab the live height before cancelling, so a second click
         mid-flight continues from what is on screen rather than
         snapping to the value the last animation was heading for. */
      var from;
      if(anim){from=wrap.getBoundingClientRect().height;anim.cancel();anim=null}

      if(!d.open){
        d.open=true;
        wrap.style.height='auto';
        var full=wrap.getBoundingClientRect().height;
        wrap.style.height='';
        if(from===undefined){from=0}
        anim=wrap.animate(
          [{height:from+'px',opacity:from>0?1:0},{height:full+'px',opacity:1}],
          {duration:420,easing:EASE}
        );
        anim.onfinish=function(){anim=null};
      }else{
        if(from===undefined){from=wrap.getBoundingClientRect().height}
        anim=wrap.animate(
          [{height:from+'px',opacity:1},{height:'0px',opacity:0}],
          {duration:340,easing:EASE}
        );
        anim.onfinish=function(){anim=null;d.open=false};
      }
    });
  }

  /* ---- boot ------------------------------------------------------ */
  function boot(){
    try{ arm(document) }catch(e){}
    try{ wireFaq(document) }catch(e){}
    try{ initScroll() }catch(e){}
    window.addEventListener('scroll',sweepSoon,{passive:true});
    setTimeout(sweep,2200);
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot)}
  else{boot()}

  /* Theme editor re-renders sections in place; pick up the new nodes. */
  document.addEventListener('shopify:section:load',function(){
    try{ arm(document) }catch(e){}
    try{ wireFaq(document) }catch(e){}
    setTimeout(sweep,800);
  });
})();
